import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Component from "./component";
import { setDetails } from "../pre-delivery-inspection-lead-form-parent/actions";

const mapStateToProps = ({ preDeliveryInspectionLeadData: { brand, model } }) => {
    return {
        brand,
        model
    };
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    setDetailsConnect: setDetails
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Component);
